import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastService } from '../../../../services/toast.service';
import { DialogService } from '../../../../services/dialog.service';
import { CardioService } from '../../../../services/cardio.service';

interface Cardio {
  id: number;
  nome: string;
  distanciaAlvoKm?: number;
  minutos?: number;
}

@Component({
  selector: 'app-admin-cardio',
  templateUrl: './admin-cardio.component.html',
  styleUrls: ['./admin-cardio.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminCardioComponent implements OnInit {

  form!: FormGroup;
  editando = false;

  dataSource!: MatTableDataSource<Cardio>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'id',
    'nome',
    'distancia',
    'minutos',
    'actions',
  ];

  constructor(
    private fb: FormBuilder,
    private service: CardioService,
    private toastService: ToastService,
    private dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.load();
  }

  buildForm() {
    this.form = this.fb.group({
      id: [0],
      nome: [''],
      distanciaAlvoKm: [null],
      minutos: [null]
    });
  }

  load() {
    this.service.getAll().subscribe(res => {
      this.dataSource = new MatTableDataSource(res);

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  editar(item: Cardio) {
    this.editando = true;
    this.form.patchValue(item);
  }

  novo() {
    this.editando = false;

    this.form.reset({
      id: 0,
      nome: '',
      distanciaAlvoKm: null,
      minutos: null
    });
  }

  salvar() {
    const data = this.form.value as Cardio;

    if (this.editando) {
      this.service.update(data).subscribe({
        next: () => {
          this.toastService.show('Editado com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        }
      });

    } else {

      this.service.create(data).subscribe({
        next: () => {
          this.toastService.show('Criado com sucesso', { type: 'success' });
          this.novo();
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao criar!', { type: 'danger' });
        }
      });

    }
  }

  async remover(id: number) {
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.service.delete(id).subscribe({
        next: () => {
          this.toastService.show('Excluído com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao excluir!', { type: 'danger' });
        }
      });
    }
  }
}